<template>
  <div>
    <Card style="padding-bottom: 40px">
      <Row>
        <Form :label-width="100">
          <Col :span="6">
            <FormItem label="区县">
              <Select v-model="WarningSpiritForm.indexCode" style="width: 100%" @on-change="getWarningSpiritData"
                      clearable @on-clear="getWarningSpiritData">
                <Option v-for="(item,index) in countList" :key="index" :value="item.indexCode"
                        :label="item.name"></Option>
              </Select>
            </FormItem>
          </Col>
        </Form>
      </Row>
      <Table
        :loading="WarningSpiritLoading"
        :columns="WarningSpiritColumns"
        :data="WarningSpiritData"
        :border="true"
        :highlight-current-row="true"
      ></Table>
      <Page style="float: right;margin-top: 10px"
            show-sizer
            show-total
            transfer
            :total="WarningSpiritTotal"
            :page-size="WarningSpiritPageSize"
            :page-size-opts="pageSizeOpts"
            :current-page="WarningSpiritCurrentPage"
            @on-change="WarningSpiritPageChange"
            @on-page-size-change="WarningSpiritPageSizeChange"
      ></Page>
    </Card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      WarningSpiritLoading: true,
      WarningSpiritTotal: 0,
      WarningSpiritColumns: [{
        title: '事件简介',
        align: 'center',
        key: 'eventTypeDesc'
      }, {
        title: '设备编码',
        align: 'center',
        key: 'code'
      }, {
        title: '开始时间',
        align: 'center',
        render: (h, params) => {
          return h('div', this.$moment(params.row.startTime).format('YYYY-MM-DD HH:mm:ss'))
        }
      }, {
        title: '结束时间',
        align: 'center',
        render: (h, params) => {
          return h('div', params.row.endTime === null ? '暂未结束' : this.$moment(params.row.endTime).format('YYYY-MM-DD HH:mm:ss'))
        }
      }, {
        title: '事件来源',
        align: 'center',
        key: 'sourceName'
      }, {
        title: '地址',
        align: 'center',
        key: 'address'
      }],
      WarningSpiritData: [],
      WarningSpiritPageSize: 10,
      pageSizeOpts: [10, 20, 30, 40],
      WarningSpiritCurrentPage: 1,
      countList: [],
      WarningSpiritForm: {
        indexCode: ''
      },
    }
  },
  mounted() {
    this.getDeptList()
  },
  methods: {
    // 获取所有区县
    getDeptList() {
      this.$http.get('/api/getLowerLevelDepts').then(res => {
        if (res.status === 200) {
          this.countList = res.data
          this.WarningSpiritForm.indexCode = this.countList[0].indexCode
          this.getWarningSpiritData()
        }
      })
    },
    getWarningSpiritData() {
      console.log(this.WarningSpiritForm.indexCode)
      if (!this.WarningSpiritForm.indexCode) {
        this.WarningSpiritForm.indexCode = this.countList[0].indexCode
      }
      this.WarningSpiritLoading = true
      let request = {
        indexCode: this.WarningSpiritForm.indexCode === '' ? null : this.WarningSpiritForm.indexCode
      }
      this.$http.post(`/api/getGaodeEventList?page=${this.WarningSpiritCurrentPage}&size=${this.WarningSpiritPageSize}`, request).then(res => {
        console.log(res)
        if (res.status === 200) {
          this.WarningSpiritData = res.data.data
          this.WarningSpiritTotal = res.data.recordsTotal
          this.WarningSpiritLoading = false
        }
      })
    },
    WarningSpiritPageChange(page) {
      this.WarningSpiritCurrentPage = page
      this.getWarningSpiritData()
    },
    WarningSpiritPageSizeChange(pageSize) {
      this.WarningSpiritPageSize = pageSize
      this.getWarningSpiritData()
    }
  },
}
</script>
<style scoped>

</style>
